/**
 * Create a string putting the size, format, and transformation of an image together as a search parameter.
 */
const buildRule = (size, format, transformation) => ['move', size, format, transformation].filter(Boolean).join('-');
/**
 * Set the search parameter "rule" of an image URL to contain size, format, and transformation using {@link buildRule}.
 * @returns String-based new URL with the added search parameter
 */
export const getYamsImageUrl = (url, size, format, transformation) => {
    url.searchParams.set('rule', buildRule(size, format, transformation));
    return url.href;
};
